export default {
    message: {
        "availability": "Disponibilité",
        "shipping_preparation": "Délai de livraison estimé",
        "days": "Jours",
        "quantity": "Quantité",
        "add_to_cart": "Ajouter au panier",
        "quantity_no_available": "La quantité demandée n'est actuellement pas disponible",
        "product_no_available": "Produits en arrivée",
        "choose": "Choisir",
        "Loading": "Chargement ...",
    },
}
